<div class="container">
  <div class="row">
    <div class="col-md-12">
      @for (diffGroup of diffGroups; track diffGroup) {
        @if (diffGroup.diffs.length > 0) {
          <h4>{{ diffGroup.name }}</h4>
          <p-table [value]="diffGroup.diffs">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 33%"></th>
                <th style="width: 33%">Alt</th>
                <th style="width: 33%">Neu</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-diff>
              <tr [pSelectableRow]="diff">
                <td>{{diff.displayName}}</td>
                <td class="diff-value">{{diff.oldValue}}</td>
                <td class="diff-value">{{diff.newValue}}</td>
              </tr>
            </ng-template>
          </p-table>
        }
      }
    </div>
  </div>
</div>
